import { faCircleInfo } from '@fortawesome/free-solid-svg-icons/faCircleInfo';
import { Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { AlertNewBooking } from 'components/CreateBooking/UI/AlertNewBooking';
import { FunctionComponent, PropsWithChildren } from 'react';

export interface InfoAlertProps extends PropsWithChildren {
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        alert: {
            margin: 0
        },
        text: {
            fontSize: 14,
            lineHeight: '20px'
        }
    })
);

export const InfoAlert: FunctionComponent<InfoAlertProps> = props => {
    const classes = useStyles(props);

    return (
        <AlertNewBooking
            bWidth="2px"
            icon={faCircleInfo}
            iconSize="lg"
            iconColor="#BAA997"
            bgColor="#F8F5F1"
            bdColor="#BCB8AE"
            className={clsx(classes.alert, props.className)}
        >
            <Typography className={classes.text}>{props.children}</Typography>
        </AlertNewBooking>
    );
};

export default InfoAlert;
